import { useState, useEffect } from "react";
import { BreakpointConfig } from "@/services/breakpoints";
import debounce from "lodash/debounce";
import { BreakpointType } from "@/types";



// Simple hook to return the legacy breakpoint string.
// Use CSS media and container queries instead of this hook.
const useLegacyBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<BreakpointType>();

  useEffect(() => {
    const { breakpoint: initialBreakpoint } = BreakpointConfig.onResize(window);
    setBreakpoint(initialBreakpoint as BreakpointType);

    const handleResize = debounce(() => {
      const { breakpoint: newBreakpoint } = BreakpointConfig.onResize(window);
      setBreakpoint(newBreakpoint as BreakpointType);
    }, BreakpointConfig.debounce);

    window.addEventListener("resize", handleResize);
    
    return () => {
      handleResize.cancel();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return breakpoint;
};

export default useLegacyBreakpoint;
